import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { FIELD_LABEL_CLASSES, SELECT_STYLING_PROPS } from "@/constants/forms"
import type { CompanyRegistrationType } from "@/graphql/codegen/graphql"
import { CompanyRegistrationTypeListToLabel } from "@/screens/CompanySettings/Registration/constants"

const options = Object.entries(CompanyRegistrationTypeListToLabel).map(([key, value]) => (
  <MenuItem key={key} value={key}>
    {value}
  </MenuItem>
))

const RegistrationTypeSelect: FC<{
  name: string
  disabled?: boolean
}> = ({ name, disabled = false }) => {
  const methods = useFormContext()

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field }) => (
        <FormControl fullWidth data-testid={name}>
          <InputLabel id={name} className={FIELD_LABEL_CLASSES}>
            Registration Type<span className='text-red-600'>*</span>
          </InputLabel>
          <Select
            {...field}
            {...SELECT_STYLING_PROPS}
            labelId={name}
            disabled={disabled}
            defaultValue={field.value}
            renderValue={(key: CompanyRegistrationType) => {
              if (!key) {
                return <span className='text-gray-500'>Select One</span>
              }

              return CompanyRegistrationTypeListToLabel[key] ?? ""
            }}
          >
            {options}
          </Select>
        </FormControl>
      )}
    />
  )
}

export default RegistrationTypeSelect
